import React, { useState } from 'react';
import { RenderComponentDropArea } from '../ComponentDropArea';
import { getAllTypes_component, DnD_element_type } from '../common/ConstantValues';
import { getIcon } from '../GetMaterialIcon';
import {colorPalette} from 'material-icons-react'

import classnames from 'classnames'

import './ComponentTrash.css'

/**
 * Except 'MESSAGE'
 */
const getAllTypes_component_filtered = getAllTypes_component.filter((value) => value !== DnD_element_type.ELEMENT.MESSAGE)

const ComponentTrash = (props) => {
  const [ mouseHover, setMouseHover ] = useState(false)
  const handleComponentOnDrop = (e) => {
    console.log('trash component dropped => e :', e);
    props.onDrop(e)
  }


  const onMouseInOut = (inOutValue) => {
    setMouseHover(inOutValue)
  }

  const trashAreaClassname = classnames('trash-component-area', 'dashed-box', {
    'hover': mouseHover,
  })

  return (
    <div className={trashAreaClassname}>
      <RenderComponentDropArea
        key={'trash-component-drop-area'}
        onDrop={handleComponentOnDrop}
        DnDOverContent={TrashOverContent}
        overContentArg={null}
        allowed_types={[...getAllTypes_component_filtered, DnD_element_type.COMPONENT.NORMAL.BUTTON.inDepth, DnD_element_type.COMPONENT.NORMAL.IMAGE.inDepth, DnD_element_type.COMPONENT.NORMAL.TEXT.inDepth]}
        customStyle={{...trashDropArea_style, backgroundColor: 'transparent', customStyle: 'absolute'}}
        onMouseInOut={onMouseInOut}
        blockOverCon={true}
      >
        
      </RenderComponentDropArea>
    </div>
  )
}

const trashDropArea_style = {
  width: '100%', 
  minHeight: 197, // 200 - 3 (border value) 
  backgroundColor:'#e74c3c', 
  // opacity: 0.5,
  borderRadius: 10,
}

const dashedBox_style = {
  width: '100%',
  height: '200px',
  textAlign: 'center',
  border: '3px solid grey',
  borderStyle: 'dashed',
  borderRadius: '10px',
  lineHeight: '190px',
}

const TrashOverContent = () => (
  <div className='trash-component-over dashed-box'></div>
)

export default ComponentTrash